export default "__VITE_ASSET__B8Od_ojz__"